import { render } from "./admin-login.vue?vue&type=template&id=9ac653b6&scoped=true"
import script from "./admin-login.vue?vue&type=script&lang=js"
export * from "./admin-login.vue?vue&type=script&lang=js"

import "./admin-login.vue?vue&type=style&index=0&id=9ac653b6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac653b6"]])

export default __exports__